import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import { compose, nest } from 'recompose'
import { connect } from 'react-redux'
import injectSagas from 'helpers/injectSagas'
import T from 'i18n-react'

import Dialog from 'react-toolbox/lib/dialog'
import Card from './Card'
import Actions from './Actions'
import Table from './Table'
import TableNavigation from './TableNavigation'
import Divider from 'components/fulcrum/divider/Divider'
import CardHeader from 'components/custom/Card/CardHeader'
import Section from 'components/custom/Section/Section'
import ProgressBarHoc from 'containers/Async/AsyncProgressBarHoc'

import sagas from './sagas'

import {
  MODULE_NAME,
  FETCH_PARTNER_SITES,
} from './constants'

import {
  fetchPartnerSites,
  changePageSize,
  updateCurrentPage,
  incrementPage,
  decrementPage,
  changeSearchValue,
  changePartnerSiteEnable,
} from './actions'

import {
  setInactiveSiteDialog,
} from 'containers/Admin/Client/Client/actions'

import {
  countSelector,
  pageSizeSelector,
  currentPageSelector,
  partnerSitesSelector,
  selectedPartnerSitesSelector,
  isFirstPageSelector,
  isLastPageSelector,
  searchValueSelector,
} from './selectors'

import {
  activeSiteDialogSelector,
} from 'containers/Admin/Client/Client/selectors'

import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    pageSize: pageSizeSelector(state),
    count: countSelector(state),
    page: currentPageSelector(state),
    partnerSites: partnerSitesSelector(state),
    selectedPartnerSites: selectedPartnerSitesSelector(state),
    isLastPage: isLastPageSelector(state),
    isFirstPage: isFirstPageSelector(state),
    searchValue: searchValueSelector(state),
    active: activeSiteDialogSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleInactiveDialog: () => dispatch(setInactiveSiteDialog()),
    fetchPartnerSites: () => dispatch(fetchPartnerSites()),
    changePageSize: (size) => dispatch(changePageSize(size)),
    incrementPage: () => dispatch(incrementPage()),
    decrementPage: () => dispatch(decrementPage()),
    onSearch: (value) => dispatch(changeSearchValue(value)),
    onEnable: (value) => dispatch(changePartnerSiteEnable(value)),
  }
}

const ProgressBar = ProgressBarHoc(() => <div/>)([FETCH_PARTNER_SITES])

class PartnerSiteSelection extends Component {
  onDone = () => this.props.toggleInactiveDialog()

  actions = [
    { label: 'Done', onClick: this.onDone },
  ]

  render() {
    const {
      active,
      pageSize,
      count,
      page,
      partnerSites,
      selectedPartnerSites,
      updatePageSize,
      changePageSize,
      incrementPage,
      decrementPage,
      isLastPage,
      isFirstPage,
      onSearch,
      searchValue,
      onEnable,
      toggleInactiveDialog,
    } = this.props

    return (
      <Dialog
        actions={this.actions}
        active={active}
        title={T.translate('containers.admin.clientSiteDialog.index.title')}
        type='fullscreen'
        onOverlayClick={toggleInactiveDialog}
        onEscKeyDown={toggleInactiveDialog}
        theme={styles}
      >
        <Actions
          onSearch={onSearch}
          searchValue={searchValue}
        />
        <Flex auto styleName='tableContainer'>
          <Table
            source={partnerSites}
            selected={selectedPartnerSites}
            onSelect={onEnable}
          />
        </Flex>
        <ProgressBar/>
        <TableNavigation
          page={page}
          pageSize={pageSize}
          count={count}
          changePageSize={changePageSize}
          incrementPage={incrementPage}
          decrementPage={decrementPage}
          isLastPage={isLastPage}
          isFirstPage={isFirstPage}
        />
      </Dialog>
    )
  }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ [MODULE_NAME]: sagas })
const enhance = compose(
  withSagas,
  withConnect,
  withStyle
)
const PartnerSiteSection = enhance(PartnerSiteSelection)

export default nest(Section, PartnerSiteSection)
